<app-section-quick-actions section="shop" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Harmony Hall</h1>
  <div class="atmos-page__header-actions">
    <a class="atmos-btn atmos-btn--sm" href="https://sky-children-of-the-light.fandom.com/wiki/Harmony_Hall" target="_blank" rel="noopener">
      <mat-icon>open_in_new</mat-icon>
      <span>Wiki</span>
    </a>
  </div>
</header>

<section class="atmos-card atmos-shop-harmony__section">
  <header class="atmos-shop-harmony__section-header">
    <h2 class="atmos-section__title">Spirit trees</h2>
  </header>
  <div class="atmos-card__body atmos-shop-harmony__section-body">
    <div class="atmos-spirit-trees">
      <app-spirit-tree
        [tree]="tree"
        [name]="'Harmony Hall Guide'"
        [highlightNode]="highlightNode()"></app-spirit-tree>
    </div>
  </div>
</section>

@if (igcShops.length) {
  <section class="atmos-card atmos-shop-harmony__section">
    <header class="atmos-shop-harmony__section-header">
      <h2 class="atmos-section__title">In-game currency</h2>
    </header>
    <div class="atmos-card__body atmos-shop-harmony__section-body">
      <div class="atmos-shop-harmony__igc-grid">
        @for (shop of igcShops; track shop.guid) {
          <div class="atmos-card atmos-shop-harmony__igc">
            <div class="atmos-card__body">
              <h3 class="atmos-shop-harmony__igc-title">{{ shop.name }}</h3>
              <app-item-list
                [itemList]="shop.itemList!"
                [highlightNode]="highlightNode()"></app-item-list>
            </div>
          </div>
        }
      </div>
    </div>
  </section>
}

@if (iapShops.length) {
  <section class="atmos-card atmos-shop-harmony__section">
    <header class="atmos-shop-harmony__section-header">
      <h2 class="atmos-section__title">In-app purchases</h2>
    </header>
    <div class="atmos-card__body atmos-shop-harmony__section-body">
      <div class="atmos-shop-harmony__iap-grid">
        @for (shop of iapShops; track shop.guid) {
          @for (iap of shop.iaps; track iap.guid) {
            <app-iap-card
              [iap]="iap"
              [highlightIap]="highlightIap()"
              (purchasedToggle)="togglePurchased(iap)"
              (giftedToggle)="toggleGifted(iap)"></app-iap-card>
          }
        }
      </div>
    </div>
  </section>
}
